import { render, staticRenderFns } from "./TabletMenuItem.vue?vue&type=template&id=ac5868f0&"
import script from "./TabletMenuItem.vue?vue&type=script&lang=js&"
export * from "./TabletMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconRightArrowMenu: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconRightArrowMenu.vue').default})
